import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/SheildCheck";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf';  
import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '10px 30px',
        fontSize: '9px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    },
    sectionTitle: {
        fontFamily: 'HelveticaBold',
        textAlign: 'center',
        marginBottom: '15px',
        marginTop: '20px'
    },
    clauseNumber: {
        maxWidth: 15,
        minWidth: 15,
        marginRight: 8
    },
    agreebox: {
        maxWidth: 15,
        minWidth: 15, 
    },
    agreeline: {
        marginTop: 18,
        maxWidth: 15,
        minWidth: 15,
        maxHeight: 15,
        minHeight: 15,
        border: '1px solid #000', 
    }
});


let primaryColor = "#000"
let ltd = "___________________"
let sk = "___________________"
let email = "___________________"
let tel = "_____________" 
let BOGbankAccount = "___________________"
let TBCbankAccountGel = "___________________"
let TBCbankAccountUSD = "___________________"
let address = "___________________"
let director_position = "___________________"
let director = "___________________"
let director_pn = "___________________"

if(baseFileURL === 'https://finance.automoby.ge') {
    primaryColor = "#235e82"
    ltd = "შ.პ.ს. „ავტომობი“"
    sk = "446977022" 
    email = "info@automoby.ge" 
    tel = "0322 11 55 22 " 
    address = "დ.აღმაშენებლის 154, თბილისი " 
    BOGbankAccount = "GE74BG0000000533900476"
    TBCbankAccountGel = "___________________"
    TBCbankAccountUSD = "___________________"
    director_position = "დირექტორი"
    director = "ნინო ჩანადირი"
    director_pn = "01024069247"

} else if(baseFileURL === 'https://crm.aig.com.ge' || baseFileURL === 'https://crmdev.aig.com.ge') {

    primaryColor = "#da0429" 
    ltd = "შ.პ.ს. „ავტო იმპორტ ჯორჯიას“"
    sk = "406203120"
    email = "info@aig.com.ge" 
    tel = "0322 11 55 22" 
    address = "თბილისი, ც. დადიანის 123/235" 
    BOGbankAccount = "GE19BG0000000131217994"
    TBCbankAccountGel = "GE54TB7734536020100004"
    TBCbankAccountUSD = "GE17TB7734536120100007"
    director_position = "ადმინისტრაციული დეპარტამენტის ხელმძღვანელი"
    director = "მარიამ აქულაშვილი"
    director_pn = "01011091639"
}


const MyDocument = ({ car }) => (
    <Document>
        <Page size="A4" style={styles.page}>
 
            <View style={styles.sectionTitle}>
                <Text>კონფიდენციალობის განაცხადი</Text>
                <Text>{ltd} მიერ სს „სადაზღვევო კომპანია ჯი პი აი ჰოლდინგისთვის“ </Text>
                <Text>მონაცემთა გაზიარების თაობაზე </Text> 
            </View>

            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <Text>
                    ავტოსატრანსპორტო დაზღვევის პოლისის განაცხადის განხილვის ან/და ავტოსატრანსპორტო საშუალების დაზღვევის
                    მიზნით, {ltd} მიერ (საიდენტიფიკაციო კოდი: {sk}, იურიდიული მისამართი: საქართველო,
                    თბილისი, სამგორის რაიონი, ვარკეთილი-3ის დასახლება, IV მიკრო/რაიონი, კორპუსი 413, ბინა 96) (შემდგომში- ,,ავტოდილერი’’) უფლებამოსილია სს „სადაზღვევო კომპანია ჯი პი აი ჰოლდინგს“ (საიდენტიფიკაციო კოდი: 204426674, იურიდიული
                    მისამართი: კოსტავას ქ. №67, ქ. თბილისი, საქართველო) (შემდგომში - „ჯიპიაი/მზღვეველი“) თქვენი პერსონალური მონაცემები
                    (სახელი, გვარი, პირადი ნომერი, დაბადების თარიღი, ავტოსატრასნსპორტო საშუალების სარეგისტრაციო ნომერი, გამოშვების
                    წელი, მარკა მოდელი, კატეგორია, საშის კოდი, ვინ კოდი) გადასცეს მხოლოდ თქვენი მიერ წინამდებარე დოკუმენტის
                    საშუალებით გამოხატული თანხმობის საფუძველზე, რომელიც მომზადებულია “პერსონალურ მონაცემთა დაცვის შესახებ”
                    საქართველოს კანონის (კანონის მე-5 მუხლის პირველი პუნქტის „ა“ ქვეპუნქტი) შესაბამისად.
                </Text>
            </View>
    
            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <Text>
                    გაცნობებთ, რომ ავტო-დილერის მიერ მზღვეველისათვის ხორციელდება მხოლოდ ზემოთ აღნიშნული პერსონალური
                    მონაცემების გადაცემა, რომელიც ავტოცენტრის მიერ ინახება საქართველოს კანონმდებლობით დაკისრებული ვალდებულების
                    შესრულების მიზნებისთვის; ხოლო მზღვეველის მიერ - იმ ვადით, რაც აუცილებელია სადაზღვევო პოლისის შეძენის მიზნით
                    განაცხადის განხილვის, მისთვის სადაზღვევო მომსახურების გაწევის ან/და “ჯიპიაის” მიერ საქართველოს კანონმდებლობით
                    დაკისრებული ვალდებულების შესრულების მიზნებისთვის. შენახვის ვადის გასვლისთანავე, პერსონალური მონაცემის
                    შემცველი ყველა დოკუმენტი ექვემდებარება განადგურებას ან/და წაშლას, ფორმატის შესაბამისად, მზღვეველში არსებული
                    შენახვის ვადების პოლიტიკის შესაბამისად.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <Text>
                     თქვენ, როგორც მონაცემთა სუბიექტი, უფლება გაქვთ მიმართოთ ავტო-დილერს ან/და მზღვეველს და მოითხოვოთ
ინფორმაცია თქვენს შესახებ მონაცემების დამუშავების შესახებ, ასევე, მოითხოვოთ მონაცემთა გაცნობა და ასლების მიღება,
მონაცემთა გასწორება, განახლება, შევსება, დამუშავების შეწყვეტა, წაშლა ან განადგურება, დაბლოკვა, გადატანა,
ავტომატიზებული ინდივიდუალური გადაწყვეტილების მიღება, თანხმობის გამოხმობა და განახორციელოთ საქართველოს
კანონმდებლობით გათვალისწინებული სხვა უფლებები.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <Text>
                   გაცნობებთ, რომ თქვენი პერსონალური მონაცემები შეიძლება გაზიარდეს/გადაეცეს მხოლოდ სახელმწიფო ან/და
ადმინისტრაციულ ორგანოებს საქართველოს კანონმდებლობის ან/და სასამართლო გადაწყვეტილების/განჩინების საფუძველზე,
ასევე, გადაეცეს კონტრაქტორებს მათ შორის გაფორმებული ხელშეკრულების საფუძველზე, მხოლოდ იმ მოცულობით, რაც
აუცილებელია მზღვეველის მიერ ლეგიტიმური მიზნის მისაღწევად. 
                </Text>
            </View>

            <View style={{   marginBottom: 5 }}>
                <Text>
                   სადაზღვევო მომსახურების ფარგლებში (მათ შორის, სადაზღვევო პოლისის განაცხადის განხილვისას) დამუშავებულ
პერსონალურ მონაცემებთან დაკავშირებით ნებისმიერ დროს შეგიძლიათ მიმართოთ სს „დაზღვევის საერთაშორისო კომპანია
ჯიპიაის“ პერსონალურ მონაცემთა დაცვის ოფიცერს, რომლის რეკვიზიტებია: შპს „დეითა ფრაივისი“ (ს/კ: 400272469),
ელექტრონული ფოსტა : info@dataprivacy.ge
                </Text>
            </View>
    

            <View style={{fontFamily: 'HelveticaBold', marginBottom: '5px'}}>
                <Text>
                    წინამდებარე დოკუმენტის საფუძველზე, განმცხადებელი მიიჩნევა ინფორმირებულად მის შესახებ მზღვეველის მიერ
მონაცემების დამუშავების თაობაზე. 
                </Text>
            </View>
 
            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <View style={{paddingRight: 35}}>
                    <Text>
                        ვადასტურებ, რომ გავეცანი მზღვეველის მიერ შემუშავებულ დოკუმენტს სახელწოდებით
                        „კონფიდენციალობის განაცხადი {ltd} მიერ სს „სადაზღვევო კომპანია
                        ჯი პი აი ჰოლდინგისთვის“ მონაცემთა გაზიარების თაობაზე’’ და ვაცხადებ თანხმობას და
                        ავტოცენტრს ვანიჭებ უფლებას ჩემი პერსონალური მონაცემები გაუზიაროს „სადაზღვევო
                        კომპანია ჯი პი აი ჰოლდინგს“, დაზღვევის პოლისის შეძენის მიზნით განცხადების განხილვის
                        ან/და სადაზღვევო ხელშეკრულების დადების მიზნით.  
                    </Text>
                </View>

                <View style={styles.agreebox}>
                    <View style={styles.agreeline}>
                            
                    </View>
                </View>
            </View>


            <View style={{ flexDirection: "row", marginBottom: 5 }}>
                <View style={{paddingRight: 35}}>
                    <Text>
                        ვადასტურებ, რომ გავეცანი მზღვეველის მიერ შემუშავებულ დოკუმენტს სახელწოდებით
                        „კონფიდენციალობის განაცხადი {ltd} მიერ სს „სადაზღვევო კომპანია
                        ჯი პი აი ჰოლდინგისთვის“ მონაცემთა გაზიარების თაობაზე’’ და უარს ვაცხადებ
                        ავტოცენტრის მიერ ჩემი პერსონალური მონაცემების „სადაზღვევო კომპანია ჯი პი აი
                        ჰოლდინგისათვის“ გადაცემის თაობაზე, დაზღვევის პოლისის შეძენის მიზნით განცხადების
                        განხილვის ან/და სადაზღვევო ხელშეკრულების დადების მიზნით
                    </Text>
                </View>

                <View style={styles.agreebox}>
                    <View style={styles.agreeline}>
                            
                    </View>
                </View>
            </View>

 
 
  
                <View style={{ marginTop: '15px', fontFamily: 'HelveticaBold' }}>
                    <Text>{car.client.firstname} {car.client.lastname}  </Text>
                    <Text>პ/ნ: {car.client.personal} </Text>
                    <Text>ტელ: {car.client.mobile} </Text>  
                    <Text> </Text>
                    <Text style={{ marginBottom: '15px'}} >ხელმოწერა ______________________</Text>
                 </View>
   



        </Page>
    </Document>
);


const PrivacyPolicy = ({ carItem }) => {
      const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'Contract.pdf';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}> <PDFicon />{t('PrivacyPolicy')}</span>
    );
};

 

export default PrivacyPolicy;